import ErrorBoundary from '@components/ErrorBoundary';
import Transcripts from '@components/interview/details/Transcripts';
import PageContainer from '@components/PageContainer';
import Spinner from '@components/spinner/Spinner';
import { Suspense } from 'react';

export default function InterviewTranscripts() {
  return (
    <PageContainer title={'Interview | Transcripts'}>
      <ErrorBoundary>
        <Suspense fallback={<Spinner />}>
          <Transcripts />
        </Suspense>
      </ErrorBoundary>
    </PageContainer>
  );
}
